import { Button, Table } from "antd";
import { useMemo, useState } from "react";
import { SendOutlined } from "@ant-design/icons";
import PdfViewer from "../../../components/shared/PdfViewer";

const OpenSignTable = (props) => {
  const { templates, loading } = props;

  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const columns = useMemo(
    () => [
      {
        title: "Name",
        dataIndex: "Name",
      },
      {
        title: "Note",
        dataIndex: "Note",
      },
      {
        title: "Created At",
        dataIndex: "createdAt",
        render: (date) => new Date(date).toLocaleString(),
      },

      {
        title: "Actions",
        key: "actions",
        width: "5%",
        render: (_, record) => (
          <Button
            icon={<SendOutlined />}
            onClick={() => setSelectedTemplate(record)}
          />
        ),
      },
    ],
    [],
  );

  return (
    <>
      <Table
        columns={columns}
        dataSource={templates}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 10 }}
        scroll={{ x: "max-content" }}
      />
      {selectedTemplate && (
        <PdfViewer
          pdfUrl={selectedTemplate?.URL}
          onClose={() => setSelectedTemplate(null)}
          onError={() => {}}
        />
      )}
    </>
  );
};

export default OpenSignTable;
